export default __webpack_public_path__ + "42bf8b8abb9d01e78bf7753fc51862db.svg";